import { render } from "./FeatureFlagSection.vue?vue&type=template&id=46fb9930&scoped=true"
import script from "./FeatureFlagSection.vue?vue&type=script&lang=js"
export * from "./FeatureFlagSection.vue?vue&type=script&lang=js"

import "./FeatureFlagSection.vue?vue&type=style&index=0&id=46fb9930&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46fb9930"]])

export default __exports__